import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "dropdown-menu",
  class DropdownMenu extends WYATTElement {
    constructor() {
      super();

      this.toggleButton = this.querySelector("[data-dropdown-toggle]");
      this.menu = this.querySelector("[data-dropdown-menu]");
      this.items = this.menu.querySelectorAll("[data-dropdown-item]");
      this.itemsLength = Array.from(this.items).length;
      this.activeItemIdx = 0;
      this.isOpen = false;

      this.toggleButton.setAttribute("aria-expanded", "false");
      this.toggleButton.setAttribute("aria-haspopup", "true");
      this.menu.setAttribute("role", "menu");

      this.items.forEach((menuItem) => {
        menuItem.setAttribute("role", "menuitem");
      });

      this.toggleButton.addEventListener(
        "click",
        this.handleToggleClick.bind(this),
      );
      this.toggleButton.addEventListener(
        "keydown",
        this.handleToggleKeydown.bind(this),
      );
      this.menu.addEventListener("keydown", this.handleMenuKeydown.bind(this));
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      document.removeEventListener("click", this.handleDocumentClick);
    }

    handleToggleClick(e) {
      e.preventDefault();
      this.toggle();
    }

    handleDocumentClick(e) {
      if (!this.contains(e.target)) {
        this.close();
      }
    }

    handleToggleKeydown(e) {
      const { key } = e;
      if (
        (key === "ArrowDown" || key === " " || key === "Enter") &&
        !this.isOpen
      ) {
        e.preventDefault();
        this.open();
      }
    }

    handleMenuKeydown(e) {
      const idx = this.activeItemIdx;
      let newIdx = idx;

      switch (e.key) {
        case "Escape":
          e.preventDefault();
          this.close();
          this.toggleButton.focus();
          this.activeItemIdx = 0;
          break;
        case "Tab":
          e.preventDefault();
          this.close();
          this.activeItemIdx = 0;
          this.toggleButton.focus();
          break;
        case "ArrowDown":
          e.preventDefault();
          newIdx = idx < this.itemsLength - 1 ? idx + 1 : 0;
          this.items[newIdx].focus();
          this.activeItemIdx = newIdx;
          break;
        case "ArrowUp":
          e.preventDefault();
          newIdx = idx > 0 ? idx - 1 : this.itemsLength - 1;
          this.items[newIdx].focus();
          this.activeItemIdx = newIdx;
          break;
        default:
          break;
      }
    }

    open() {
      this.isOpen = true;
      this.menu.setAttribute("visible", "true");
      this.toggleButton.setAttribute("aria-expanded", "true");

      this.items[0].focus();
      document.addEventListener("click", this.handleDocumentClick.bind(this));
    }

    close() {
      this.isOpen = false;
      this.menu.setAttribute("visible", "false");
      this.toggleButton.setAttribute("aria-expanded", "false");
      document.removeEventListener("click", this.handleDocumentClick);
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
  },
);
